export default __webpack_public_path__ + "static/media/keyvisual-zollernalb.1f2b1502.jpg";